import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Phone, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useAuth } from "@/context/AuthContext";
import { tourKey } from "@/components/FirstTour";

const laterKey = (uid) => `imodesk_phone_later_${uid}`;

// Primeiro acesso do consultor sem telemóvel: pede o número (depois do tour).
export function PhonePrompt() {
  const { user, setUser } = useAuth();
  const need = user?.role === "consultor" && !user?.phone;
  const ready = () => need && localStorage.getItem(tourKey(user.id)) && !sessionStorage.getItem(laterKey(user.id));
  const [open, setOpen] = useState(false);
  const [v, setV] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!need) return undefined;
    const check = () => { if (ready()) setOpen(true); };
    const t = setTimeout(check, 600);
    window.addEventListener("imodesk:tour-done", check);
    return () => { clearTimeout(t); window.removeEventListener("imodesk:tour-done", check); };
  }, [need]); // eslint-disable-line react-hooks/exhaustive-deps
  const later = () => { sessionStorage.setItem(laterKey(user.id), "1"); setOpen(false); };
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put("/me/profile", { phone: v.trim() });
      setUser({ ...user, phone: v.trim() });
      setOpen(false);
      toast.success("Telemóvel guardado");
    } catch (err) { toast.error(apiErr(err.response?.data?.detail)); }
    setBusy(false);
  };
  if (!need) return null;
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) later(); }}>
      <DialogContent className="max-w-md" data-testid="phone-prompt">
        <div className="w-11 h-11 rounded-full bg-ec-green/10 text-ec-green grid place-items-center"><Phone size={20} /></div>
        <DialogTitle className="font-heading text-xl navy-text">Qual é o seu telemóvel?</DialogTitle>
        <DialogDescription className="text-sm text-slate-600 -mt-1">
          Aparece na página dos seus clientes e no processo, para lhe ligarem ou enviarem WhatsApp num toque.
        </DialogDescription>
        <form onSubmit={save} className="space-y-3 mt-1">
          <input value={v} onChange={(e) => setV(e.target.value)} inputMode="tel" autoComplete="tel" autoFocus placeholder="912 345 678"
            className="w-full h-12 px-4 rounded-xl border border-slate-300 text-lg tabular-nums outline-none focus:border-slate-500" data-testid="phone-prompt-input" />
          <div className="flex gap-2">
            <button type="submit" disabled={busy || v.replace(/\D/g, "").length < 9}
              className="flex-1 h-11 rounded-xl bg-ec-green text-white font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-50 transition-opacity" data-testid="phone-prompt-save">
              {busy && <Loader2 size={16} className="animate-spin" />}Guardar
            </button>
            <button type="button" onClick={later} className="h-11 px-4 rounded-xl text-slate-600 font-medium hover:bg-slate-100 transition-colors" data-testid="phone-prompt-later">Mais tarde</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
